import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const flexibilityfitnessApiService = createApi({
  reducerPath: "flexibilityfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createFlexibility: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `flexibilitytest/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getFlexibility: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `flexibilitytest/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateFlexibility: builder.mutation({
      query: ({ id, params, ...payload }) => {
        return {
          url: `flexibilitytest/${id}${params}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateFlexibilityMutation,
  useGetFlexibilityQuery,
  useUpdateFlexibilityMutation,
} = flexibilityfitnessApiService;
